import React from 'react';
import { works } from "../data/works";
import { Link } from 'react-router-dom';

export const WorksList = ({limit}) => {
    // Render a few random projects reading a works array to be displayed on home page: 
    
    return (
        <section className="projects">
            {
                works.slice(0,limit).map(work => {
                    //{/* Go over the array and read every object as JSON to be displayed on screen */ }
                    return (
                        <article className="work-item" key={work.id}>
                            <div className="mask">
                                <img src={"/images/" + work.id + ".png"} alt="img" />
                            </div>
                            <span>Categoria: {work.categories}</span>
                            <h2><Link to={"/project/" + work.id}> {work.name}</Link> </h2>
                            <h3>Tecnologias utilizadas: {work.technologies}</h3>
                        </article>
                    );
                })
            }
        </section>
    )
}
